<template>
  <div>
    <div>
      <el-dialog
        :title="mainTitle"
        :visible.sync="editVisible"
        width="500px"
        @close="closeEdit"
        @open="dlgOpen"
        @closed="dlgClosed"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
      >
        <el-form
          ref="form"
          :model="form"
          label-width="150px"
          title="web"
          style="margin-top:10px"
          v-loading="loading"
        >
          <span class="myColorStyle" style="margin-left:20px;">&nbsp;&nbsp;WEB</span>
          <el-checkbox-group v-model="webAuthIds">
            <el-checkbox
              v-for="(item,index) in webData"
              :key="index"
              :label="item.name"
              name="type"
              style="margin-left:20px;margin-top:10px;"
            ></el-checkbox>
          </el-checkbox-group>
          <!-- <el-checkbox-group v-model="webAuthIds">
            <el-checkbox label="超级管理员" name="type" style="margin-left:30px;width:100px"></el-checkbox>
            <el-checkbox label="开发工程师" name="type" style="width:100px"></el-checkbox>
            <el-checkbox label="人事经理" name="type" style="width:100px"></el-checkbox>
            <el-checkbox label="技术部经理" name="type" style="width:100px"></el-checkbox>
          </el-checkbox-group>-->
        </el-form>

        <el-form ref="form" :model="form" label-width="150px" title="app" style="margin-top:10px">
          <span class="myColorStyle" style="margin-left:20px;">&nbsp;&nbsp;APP</span>
          <el-checkbox-group v-model="appAuthIds">
            <el-checkbox
              v-for="(item,index) in appData"
              :key="index"
              :label="item.name"
              name="type"
              style="margin-left:20px;margin-top:10px;"
            ></el-checkbox>
          </el-checkbox-group>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="resetForm">取 消</el-button>
          <el-button type="primary" @click="onSubmit">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import TabResize from "@/utils/TabResizeEx.js";
import DialogResize from "@/utils/DialogResize.js";
import SettingApi from "@/api/setting.js";
export default {
  mixins: [DialogResize],
  components: {},
  data() {
    return {
      loading: false,
      overAllIds: "",
      webAuthIds: [],
      appAuthIds: [],
      isShowApproval: false,
      webData: [],
      appData: [],
      mainTitle: "",
      showParentId: "",
      parentId: "",
      editVisible: false,
      organizationDlgShow: false,
      form: {
        user_id: "",
        status: "",
        realname: "",
        username: "",
        password: "",
        password_confirmation: "",
        mobile: "",
        mail: "",
        department_id: "",
        department_name: "",
        subcompany_id: "",
        subcompany_name: "",
        role: "",
        is_push_application_email: ""
      }
    };
  },
  methods: {
    init(ids, parentId) {
      this.mainTitle = "批量角色授权";
      this.editVisible = true;
      this.overAllIds = ids;
      this.parentId = parentId;
      this.loading = false;
      this.btnDisabled = false;
      this.webAuthIds = [];
      this.appAuthIds = [];
      this.initData();
    },
    //清空表单验证
    resetForm(formName) {
      this.editVisible = false;
    },
    closeEdit() {
      this.$refs["form"].resetFields();
      this.showParentId = null;
    },
    initData() {
      this.loading = true;
      this.btnDisabled = true;
      let param = {
        keyword: "",
        type: ""
      };
      SettingApi.getClass()
        .initAuthData(param)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            this.webData = res2.data.data.typeWebs;
            this.appData = res2.data.data.typeApps;
            this.loading = false;
            this.btnDisabled = false;
          } else {
            this.btnDisabled = false;
            this.loading = false;
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.btnDisabled = false;
          this.loading = false;
          this.$message.error(err);
          return false;
        });
    },
    onSubmit() {
      this.loading = true;
      this.btnDisabled = true;
      let roleIds = [];
      for (let a = 0; a < this.webAuthIds.length; a++) {
        for (let b = 0; b < this.webData.length; b++) {
          if (this.webAuthIds[a] == this.webData[b].name) {
            roleIds.push(this.webData[b].id);
          }
        }
      }
      for (let c = 0; c < this.appAuthIds.length; c++) {
        for (let d = 0; d < this.appData.length; d++) {
          if (this.appAuthIds[c] == this.appData[d].name) {
            roleIds.push(this.appData[d].id);
          }
        }
      }
      let param = {
        userIds: this.overAllIds,
        roleIds: roleIds
      };
      this.loading = true;
      SettingApi.getClass()
        .saveRoleUser(param)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            this.$message.success("保存成功！");
            //关闭弹窗
            this.editVisible = false;
            this.loading = false;
            this.btnDisabled = false;
            this.$parent.getListData(this.parentId);
            this.$parent.clearChoose();
          } else {
            this.loading = false;
            this.btnDisabled = false;
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.loading = false;
          this.btnDisabled = false;
          this.$message.error(err);
          return false;
        });
    }
  }
};
</script>
<style lang="stylus" scoped>
.operate {
  color: rgb(206, 23, 48);
}

.operate-unline {
  color: rgb(102, 121, 129);
}

.operate-o {
  color: rgb(83, 185, 92);
}

.icon-sea {
  margin: -10px;
  margin-left: 10px;
}

.myColorStyle {
  font-size: 14px;
  text-align: 'center';
  border-left: solid;
  border-left-width: 3px;
  border-left-color: $theme-color;
}
</style>
